import { createFileRoute } from '@tanstack/react-router'

import AddressCreatePage from '@/views/customer/pages/address.create.page'

export const Route = createFileRoute('/phong-nha/customer/address/create')({
  component: AddressCreatePage,
})

